module.exports = __webpack_public_path__ + "static/media/diamond.1ab1a733.svg";